import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-budget-order',
  templateUrl: './budget-order.component.html',
  styleUrls: ['./budget-order.component.css']
})
export class BudgetOrderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
